export const T = {
  en_GB: {
    settings: "Settings",
    teams: "Teams",
    pageDescription:
      "Group users into teams to filter clients and, if you choose, limit who sees them",
    accessNote:
      "Teams only limit who can see a client while “Limit access with teams” is on (Settings → Organization). Otherwise they only group clients, for example for filtering.",
  },
  nb_NO: {
    settings: "Innstillinger",
    teams: "Team",
    pageDescription:
      "Samle brukere i team for å filtrere kunder og eventuelt begrense hvem som ser dem",
    accessNote:
      "Team begrenser bare hvem som kan se en kunde når «Begrens tilgang med team» er på (Innstillinger → Organisasjon). Ellers grupperer de bare kunder, for eksempel for filtrering.",
  },
} as const;
